'use client';

import React, { useState } from 'react';
import { default as NextImage, ImageLoaderProps } from 'next/image';

interface Props {
  className?: string;
  preloadQuality?: number;
  src: string;
  alt: string;
  width: number;
  height: number;
}

const contentfulLoader = ({ src, width, quality }: ImageLoaderProps) => {
  return `${src}?w=${width}&q=${quality || 80}`;
};

export default function ShaojiangContentfulImage({
  className,
  src,
  alt = '',
  width = 0,
  height = 0,
  preloadQuality = 8,
}: Props) {
  const [preloaded, setPreloaded] = useState(false);

  if (!preloaded) {
    return (
      <NextImage
        src={src}
        width={width}
        height={height}
        alt={alt}
        loader={contentfulLoader}
        className={className}
        quality={preloadQuality}
        onLoad={() => setPreloaded(true)}
      />
    );
  }

  return (
    <NextImage
      src={src}
      width={width}
      height={height}
      alt={alt}
      loader={contentfulLoader}
      className={className}
      quality={80}
    />
  );
}
